const SELECT_TYPE = {
  default: '',
  standard: 'standard',
  float: 'float',
}

const SELECT_TYPE_CLASS = {
  [SELECT_TYPE.standard]: 'pml-dropdown__underline',
  [SELECT_TYPE.float]: 'pml-dropdown__float',
}

export { SELECT_TYPE, SELECT_TYPE_CLASS }
